import { Wallet } from "lucide-react";

/**
 * Small presentational card that renders a payment plan (milestones with
 * percentage split only). Used on Step 6 Summary and on the Public /q/:id page.
 */
export default function PaymentPlanBlock({
  plan,
  testId = "payment-plan-block",
  primary = "#C5A880",
}) {
  if (!plan || !Array.isArray(plan.milestones) || plan.milestones.length === 0) {
    return null;
  }
  const totalPct = plan.milestones.reduce((s, m) => s + (parseFloat(m.percent) || 0), 0);

  return (
    <div
      className="rounded-xl border p-4 mb-4"
      style={{
        borderColor: `${primary}44`,
        background: `linear-gradient(135deg, ${primary}14, rgba(255,255,255,0.01))`,
      }}
      data-testid={testId}
    >
      <div className="flex items-center gap-2 mb-3">
        <Wallet size={13} style={{ color: primary }} />
        <div className="overline" style={{ color: primary }}>
          Payment plan · {plan.name}
        </div>
      </div>
      {plan.description && (
        <p className="text-[12px] text-white/60 mb-3 leading-snug">
          {plan.description}
        </p>
      )}
      <div className="space-y-2">
        {plan.milestones.map((m, i) => {
          const pct = parseFloat(m.percent) || 0;
          return (
            <div
              key={`${plan.id || "plan"}-m-${i}-${m.label}-${m.percent}`}
              className="flex items-start justify-between gap-3 rounded-lg border border-white/5 bg-white/[0.02] px-3 py-2"
              data-testid={`${testId}-milestone-${i}`}
            >
              <div className="min-w-0">
                <div className="text-[13px] text-white/85 font-medium">
                  {m.label}
                </div>
                {m.note && (
                  <div className="text-[11px] text-white/45 leading-snug">
                    {m.note}
                  </div>
                )}
              </div>
              <div className="text-right shrink-0">
                <div
                  className="font-display font-bold text-[14px] leading-none"
                  style={{ color: primary }}
                >
                  {pct}%
                </div>
              </div>
            </div>
          );
        })}
      </div>
      {totalPct > 0 && totalPct < 100 && (
        <p className="text-[10px] text-amber-300/80 mt-2">
          Milestones total {totalPct}% — balance {100 - totalPct}% as mutually agreed.
        </p>
      )}
    </div>
  );
}
